export default {
  // Page titles
  pageTitle: 'Configuración de Evento | WedBox',
  settingsTitle: 'Configuración del Evento',
  settingsDescription: 'Gestiona los detalles de tu evento',
  
  // Existing basic fields
  title: "Mis Eventos",
  myEvents: "Mis Eventos",
  description: "Crea y gestiona tus eventos",
  createEvent: "Crear Evento",
  createNew: "Crear Nuevo",
  currentEvent: "Evento Actual",
  noEvents: "Sin eventos",
  addFirstEvent: "Crea tu primer evento",
  createFirstEvent: "Crea tu primer evento",
  eventCreated: "Evento creado exitosamente",
  eventUpdated: "Evento actualizado",
  eventDeleted: "Evento eliminado",
  selectEventType: "Selecciona tipo de evento",
  date: "Fecha",
  location: "Ubicación",
  guestCount: "Número de invitados",
  budget: "Presupuesto",
  status: "Estado",
  active: "Activo",
  draft: "Borrador",
  completed: "Completado",
  cancelled: "Cancelado",
  editEvent: "Editar Evento",
  deleteEvent: "Eliminar Evento",
  confirmDelete: "¿Estás seguro de que quieres eliminar este evento?",
  yes: "Sí",
  no: "No",
  save: "Guardar",
  cancel: "Cancelar",
  close: "Cerrar",
  switch: "Cambiar",
  switchEvent: "Cambiar Evento",
  switchedTo: "Cambiado a",
  currentlyActive: "Actualmente activo",
  searchEvents: "Buscar eventos",
  noEventsFound: "No se encontraron eventos",
  manage: "Gestionar",
  yourEvents: "Tus eventos",
  advancedView: "Vista Avanzada",
  basicView: "Vista Básica",

  // Bulk actions
  bulkActions: {
    title: "Acciones Masivas",
    selectAll: "Seleccionar Todo",
    selected: "seleccionado(s)",
    delete: "Eliminar",
    archive: "Archivar",
    export: "Exportar",
    duplicate: "Duplicar",
    processing: "Procesando...",
    confirmDelete: "¿Estás seguro de que quieres eliminar los eventos seleccionados?",
    description: "Gestiona múltiples eventos a la vez"
  },

  // Subscription info
  subscriptionInfo: {
    free: {
      title: "Plan Gratuito",
      description: "Genial para empezar"
    },
    essential: {
      title: "Plan Esencial",
      description: "Para eventos pequeños"
    },
    pro: {
      title: "Plan Pro",
      description: "Para eventos grandes"
    }
  },

  dashboard: {
    subtitle: "Resumen",
    title: "Panel de eventos",
    usage: "Uso",
    gridView: "Cuadrícula",
    listView: "Lista"
  },

  maxEventsReached: "Número máximo de eventos alcanzado",
  upgradeToCreateMoreEvents: "Actualiza para crear más eventos",

  // Event types
  eventTypes: {
    wedding: "Boda",
    engagement: "Compromiso",
    birthday: "Cumpleaños",
    babyShower: "Baby Shower",
    baptism: "Bautismo",
    reunion: "Reunión",
    corporate: "Evento Corporativo",
    other: "Otro",
    WEDDING: "Boda",
    PACS: "Unión civil",
    pacs: "Unión civil",
    ANNIVERSARY: "Aniversario",
    anniversary: "Aniversario",
    CORPORATE: "Evento corporativo",
    OTHER: "Otro",
    BABYSHOWER: "Baby shower",
    BAPTISM: "Bautismo"
  },

  // Form sections
  form: {
    eventDetails: "Detalles del Evento",
    basicInfo: "Información Básica",
    eventName: "Nombre del Evento",
    eventType: "Tipo de Evento",
    eventDate: "Fecha del Evento",
    eventLocation: "Ubicación del Evento",
    partners: "Parejas / Personas Principales",
    partner1: "Pareja 1 / Persona Principal", 
    partner2: "Pareja 2 (opcional)",
    firstName: "Nombre",
    lastName: "Apellido",
    placeholders: {
      eventName: 'Ej: Boda de María y Pedro',
      eventLocation: 'Ej: Castillo de Versalles, París',
      firstName: 'Nombre',
      lastName: 'Apellido',
    },
  },

  // Actions
  actions: {
    create: "Crear",
    edit: "Editar",
    delete: "Eliminar",
    duplicate: "Duplicar",
    share: "Compartir",
    setDefault: "Establecer como Predeterminado",
    selectEvent: "Seleccionar Evento",
  },

  // Date formatting
  dateFormat: {
    notSpecified: 'No especificada',
    invalid: 'Fecha inválida',
  },

  // Card details
  details: {
    title: 'Detalles del Evento',
    id: 'ID:',
    eventCount: '{{count}} eventos en total',
    singleEvent: '1 evento',
  },

  // Empty state
  empty: {
    noEventSelected: 'Ningún evento seleccionado',
    selectEventDescription: 'Por favor selecciona un evento para acceder a su configuración.',
  },

  // Success messages
  success: {
    title: 'Éxito',
    eventUpdated: 'Evento actualizado exitosamente',
  },

  // Error messages
  errors: {
    title: 'Error',
    updateFailed: 'Error al actualizar el evento',
    updateError: 'Error al actualizar el evento',
    deleteFailed: 'Error al eliminar el evento',
    deleteError: 'Error al eliminar el evento',
  },

  // Delete confirmation
  deleteConfirmation: {
    title: 'Eliminar Evento',
    description: '¿Estás seguro de que quieres eliminar el evento "{{eventName}}"? Esta acción es irreversible y todos los datos asociados serán eliminados.',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
  },

  deleteConfirmationModal: {
    title: 'Eliminar Evento',
    description: '¿Estás seguro de que quieres eliminar el evento "{{eventName}}"? Esta acción es irreversible y todos los datos asociados serán eliminados.',
    confirm: 'Eliminar',
    cancel: 'Cancelar',
  },

  // Existing features
  features: {
    aiAssistant: 'Asistente IA',
    aiAssistantDesc: 'Obtén sugerencias personalizadas y ayuda inteligente.',
    taskManagement: 'Gestión de Tareas',
    taskManagementDesc: 'Organiza y sigue todas tus tareas del evento.',
    budgetPlanning: 'Planificación de Presupuesto',
    budgetPlanningDesc: 'Gestiona tu presupuesto con herramientas de seguimiento detalladas.',
    guestManagement: 'Gestión de Invitados',
    guestManagementDesc: 'Organiza tu lista de invitados y sus respuestas.',
    vendorCoordination: 'Coordinación de Proveedores',
    vendorCoordinationDesc: 'Encuentra y gestiona tus proveedores fácilmente.',
    timelineTracking: 'Seguimiento de Cronograma',
    timelineTrackingDesc: 'Visualiza y planifica el cronograma de tu evento.',
    collaborativeTools: 'Herramientas Colaborativas',
    collaborativeToolsDesc: 'Trabaja junto con tu equipo y seres queridos.',
    documentSharing: 'Compartir Documentos',
    documentSharingDesc: 'Comparte y organiza todos tus documentos importantes.',
    mobileSynchronization: 'Sincronización Móvil',
    mobileSynchronizationDesc: 'Accede a tus datos en cualquier lugar con sincronización en la nube.',
    customTemplates: 'Plantillas Personalizadas',
    customTemplatesDesc: 'Crea y usa plantillas adaptadas a tus necesidades.',
    realTimeNotifications: 'Notificaciones en Tiempo Real',
    realTimeNotificationsDesc: 'Mantente informado de actualizaciones importantes.',
    advancedReporting: 'Informes Avanzados',
    advancedReportingDesc: 'Analiza tus datos con informes detallados.',
    duplicateDetection: 'Detección de Duplicados',
    duplicateDetectionDesc: 'Identifica eventos similares basados en nombre, tipo y fecha.'
  },

  // Test page translations
  testPage: {
    title: "🧪 Página de Prueba de Funciones Firebase",
    firebaseTest: {
      title: "Prueba de Función Firebase",
      description: "Prueba la conectividad con funciones Firebase antes de intentar eliminar la cuenta.",
      button: "Probar Función Firebase",
      result: "Resultado",
      userNotConnected: "❌ Usuario no conectado",
      testing: "🧪 Probando...",
      success: "✅ Prueba exitosa",
      error: "❌ Error",
      unknownError: "Error desconocido",
    },
    instructions: {
      title: "📋 Instrucciones",
      step1: "Haz clic en \"Probar Función Firebase\" arriba",
      step2: "Si la prueba tiene éxito, ve a Configuración → Cuenta",
      step3: "Intenta eliminar tu cuenta",
      step4: "La función backend debería funcionar sin pedir contraseña",
    },
    messages: {
      eventCreated: "✅ ¡Evento creado exitosamente! ID: {{eventId}}",
      tasksGenerated: "🎯 ¡{{count}} tareas generadas automáticamente!",
      noTasksFound: "⚠️ No se encontraron tareas. Usa el botón de depuración para generar manualmente.",
      errorLoadingTasks: "❌ Error al cargar tareas",
      errorCreatingEvent: "❌ Error",
      waitingForTasks: "🔄 Esperando 3 segundos antes de cargar tareas...",
      loadingTasks: "🔍 Cargando tareas para el evento:",
      tasksReloaded: "🔄 Recargado: {{count}} tareas encontradas",
      errorReloadingTasks: "❌ Error al recargar tareas",
      debuggingGeneration: "🔧 Depurando generación de tareas...",
      manualGenerationComplete: "✅ Generación manual completa",
      debugError: "❌ Error de depuración",
      testingExistingEvent: "🧪 Probando con evento existente...",
      eventNotFound: "❌ Evento no encontrado",
      eventFound: "📋 Evento encontrado",
      eventDate: "📅 Fecha",
      eventCountry: "🌍 País",
      notSpecified: "No especificado",
      existingTasks: "📊 Tareas existentes",
      generatingTasks: "🔧 Generando tareas (si es necesario)...",
      generationComplete: "✅ Generación completa",
      newTasks: "📊 Nuevas tareas",
      testError: "❌ Error de prueba",
      generatingForAllEvents: "🔄 Generando tareas para todos los eventos existentes...",
      noEventsFound: "📋 No se encontraron eventos",
      eventsFound: "📊 {{count}} evento(s) encontrado(s)",
      processingEvent: "🔧 Procesando",
      generatingTasksFor: "🎯 Generando tareas para",
      tasksGeneratedFor: "✅ {{count}} tareas generadas para",
      eventAlreadyHasTasks: "✅ {{name}} ya tiene {{count}} tareas",
      errorProcessingEvent: "❌ Error para",
      processingComplete: "🎉 Procesamiento completo: {{processed}} eventos procesados, {{generated}} nuevas tareas generadas",
      globalError: "❌ Error global",
    },
    eventTypes: {
      wedding: "Boda",
      birthday: "Cumpleaños",
      engagement: "Compromiso",
      babyShower: "Baby Shower",
      baptism: "Bautismo",
      other: "Otro",
    },
  },
  
  eventForm: {
    title: "Detalles del evento",
    name: "Nombre del evento",
    description: "Descripción",
    date: "Fecha",
    time: "Hora",
    location: "Lugar",
    type: "Tipo de evento",
    guests: "Número estimado de invitados",
    budget: "Presupuesto estimado",
    notes: "Notas",
    submit: "Crear evento",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    partner1: "Pareja 1",
    partner2: "Pareja 2",
    firstName: "Nombre",
    lastName: "Apellido"
  },
  
  messages: {
    createSuccess: "Evento creado exitosamente",
    updateSuccess: "Evento actualizado exitosamente",
    deleteSuccess: "Evento eliminado exitosamente",
    deleteConfirm: "¿Estás seguro de que quieres eliminar este evento?",
    error: "Ocurrió un error",
    eventUpdated: "Evento actualizado exitosamente",
    eventDeleted: "Evento eliminado exitosamente",
    updateError: "Error al actualizar",
    deleteError: "Error al eliminar",
    invalidDate: "Fecha inválida"
  },
  
  eventActions: {
    view: "Ver",
    edit: "Editar",
    delete: "Eliminar",
    duplicate: "Duplicar",
    share: "Compartir",
    setDefault: "Establecer por defecto"
  },
  
  validation: {
    accountHealth: 'Estado de la cuenta',
    problemsDetected: 'Problemas detectados con tus eventos',
    suggestions: 'Sugerencias',
    cannotCreate: 'No se puede crear un nuevo evento',
    cannotDelete: 'No se puede eliminar el evento',
    limitReached: 'Límite de eventos alcanzado',
    multipleEventsNotAllowed: 'Tu suscripción no permite múltiples eventos',
    cannotDeleteDefault: 'No se puede eliminar el evento por defecto',
    cannotDeleteLast: 'No se puede eliminar el último evento',
    duplicateFound: 'Ya existe un evento similar',
    continueAnyway: '¿Quieres continuar?',
    upgradeRequired: 'Actualización requerida',
    noEventsFound: 'No se encontraron eventos',
    noDefaultEvent: 'Ningún evento por defecto definido',
    multipleDefaultEvents: 'Múltiples eventos definidos como "por defecto"',
    eventsWithoutName: 'evento(s) sin nombre',
    healthyAccount: 'Cuenta en buen estado',
    setAnotherAsDefault: 'Define primero otro evento como evento por defecto',
    createBeforeDelete: 'Crea un nuevo evento antes de eliminar este'
  },
  
  faq: {
    convertEvent: {
      question: "¿Cómo convertir un evento a un tipo específico?",
      answer: "Puedes cambiar el tipo de evento en la configuración. Esto adaptará automáticamente las funcionalidades disponibles."
    }
  }
};
